import CompetitorSelectionPage from "../Competitors/CompetitorSelectionPage";
import { ConfigurationPageType } from "../interfaces";

// CUSTOM rather than TABLE: a map, a companion list and a property-scoped filter are
// not expressible through ConfigurationTableModel, and forcing them in would extend the
// shared table config for a single consumer. Same reasoning as SETUP_TRASH_PAGE.
export const SETUP_COMPETITOR_SELECTION_PAGE = {
  type: ConfigurationPageType.CUSTOM as const,
  component: CompetitorSelectionPage,
  menuLabel: "COMPETITOR_SELECTION",
  label: "COMPETITOR_SELECTION",
  path: "competitor-selection",
  description: "CONF_DESC_COMPETITOR_SELECTION",
  // ⚠️ `flagRequired`, not `flagDisabled`. They are not synonyms: `flagDisabled` only
  // greys the menu entry, leaving the route reachable by URL, while `flagRequired`
  // stops it being registered at all. The two existing competitor pages use
  // `flagDisabled` and are therefore URL-reachable with their flag off — do not copy
  // that here.
  flagRequired: "enable_customer_competithive" as const,
  // Same claim the page's own title makes, in the menu — so it is visible before you
  // open it rather than only after.
  isBeta: true,
};
